/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Required_Fields_NoteInputs */

const en_required_fields_note = /** @type {(inputs: Required_Fields_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Required field`)
};

const de_required_fields_note = /** @type {(inputs: Required_Fields_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`* Pflichtfeld`)
};

/**
* | output |
* | --- |
* | "* Required field" |
*
* @param {Required_Fields_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const required_fields_note = /** @type {((inputs?: Required_Fields_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Required_Fields_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_required_fields_note(inputs)
	return en_required_fields_note(inputs)
});